import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { type ITabItem, Tabs } from 'shared/ui'
import { PresetContainer } from 'shared/Preset'

import { type CreateChatbotStore } from 'pages/chatbot/store/chatbotCreateStore'
import { TextingContent } from 'pages/chatbot/ui/ChatbotCreate/TextingContent'
import { CallingContent } from 'pages/chatbot/ui/ChatbotCreate/CallingContent'
import { type IAgentType } from 'pages/chatbot/store/type'

export const ChatbotTemplateModal = observer(({ store }: { store: CreateChatbotStore }) => {
  const [activeTabKey, setActiveTabKey] = useState(store.type || 'texting')

  const tabs: ITabItem<IAgentType>[] = [
    {
      key: 'texting',
      name: 'Texting',
    },
    {
      key: 'calling',
      name: 'Calling',
      statusProps: {
        intent: 'warning',
        emphasis: 'high',
        title: 'Beta',
        size: 'label',
      },
    },
  ]

  const handleSelectTab = (tab: ITabItem<IAgentType>) => {
    setActiveTabKey(tab.key)
  }

  return (
    <PresetContainer>
      <Tabs
        tabs={tabs}
        activeTabKey={activeTabKey}
        handleSelectTab={handleSelectTab}
        marginInlineTab={18}
      />
      {activeTabKey === 'texting' && <TextingContent store={store} />}
      {activeTabKey === 'calling' && <CallingContent store={store} />}
    </PresetContainer>
  )
})
